import _ from 'lodash'
import { DEBOUNCE_DEFAULT_DELAY } from './ui.const'

/**
 * Return a className string based on array of conditions and results
 * @param array.condition
 * @param array.trueClassName
 * @param array.falseClassName
 * @returns {*}
 */
export const getClassName = (baseClassName, array) => {
  let className = baseClassName || '';

  (array || []).forEach((classItem) => {
    if (classItem.condition && classItem.trueClassName) {
      className += ` ${classItem.trueClassName}`
    }

    if (!classItem.condition && classItem.falseClassName) {
      className += ` ${classItem.falseClassName}`
    }
  })

  return className
}

/**
 * Creates and returns a new debounced version of the provided function
 * @param func
 * @param wait
 * @return {((...args: any[]) => any) & "../index".Cancelable}
 */
export const debounce = (func, wait = DEBOUNCE_DEFAULT_DELAY) => {
  return _.debounce(func, wait)
}

/**
 * Combine strings
 * @param array
 * @param by - join using comma, space etc.
 * @returns {*}
 */
export const combine = (array, by = ', ') => {
  return (array || []).filter((value) => value && value.trim()).join(by)
}

/**
 * Contact detail or dash
 * @param detail
 * @returns {*|string}
 */
export const getDetail = (detail) => {
  return (detail && detail.length) ? detail : '-'
}